import bsC13_4 from './BS/C13_4/Config';
import bsC13_5 from './BS/C13_5/Config';
import bsEnConfig from './BsEn/Config';

export default {
  ...bsC13_4,
  ...bsC13_5,
  ...bsEnConfig,
};
